// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__LSoVe","signatureButtonsRight":"ModalSign_signatureButtonsRight__2NKfG"};